"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.percentage = void 0;
var isNumber_1 = require("./isNumber");
var toFixed_1 = require("./toFixed");
function percentage(source, digits) {
    if (digits === void 0) { digits = 2; }
    var numb = Number(source);
    if (!isNumber_1.isNumber(numb))
        return source;
    return toFixed_1.toFixed(numb * 100, digits) + '%';
}
exports.percentage = percentage;
